import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  Input,
  TextField,
} from "@mui/material";
import { callAPI } from "../../../App/Helpers/callApi";
import LoadingBar from "../../../App/Components/LoadingBar/LoadingBar";
import { getBase64 } from "../../../App/Helpers/base64";
import { addEventSponsor, getEventSponsors } from "../EventSponsorsService";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  copy: {
    color: theme.palette.primary.copy,
  },
}));
export default function AddEventSponsorModal({
  openModal,
  client,
  setShowSignifier,
  setResponseMessage,
  setShowError,
  setTableData,
}) {
  const classes = useStyles();
  const [processing, setProcessing] = useState(false);
  const [fileName, setFileName] = useState("");
  const [contentType, setContentType] = useState("");
  const [encodedImage, setEncodedImage] = useState([]);
  const [name, setName] = useState("");
  const [link, setLink] = useState("");
  const [inputError, setInputError] = useState(false);

  function addSponsor() {
    if (!checkAllEntered()) {
      setInputError(true);
      return;
    }
    let json = {
      ClientId: client.id,
      Name: name,
      Link: link,
      base64: encodedImage,
      ContentType: contentType,
    };

    callAPI(
      addEventSponsor(json),
      "Sponsor Added",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    ).then(() => {
      getEventSponsors(client.id).then((response) => {
        response.forEach(
          (row) =>
            (row.imagePath = "data:" + row.contentType + ";base64," + row.logo)
        );
        setTableData(response);
        openModal(false);
      });
    });
  }

  const uploadFile = (e) => {
    var fileType = e.target.files[0].type;

    if (fileType !== "image/png" && fileType !== "image/jpeg") {
      setInputError(true);
      return;
    }
    var image = e.target.files[0];
    getBase64(image, (result) => {
      setEncodedImage(result.split("base64,")[1]);
      setFileName(e.target.files[0].name);
      setContentType(e.target.files[0].type);
    });
  };

  const checkAllEntered = () => {
    if (fileName === "" || link === "" || name === "") {
      return false;
    }
    return true;
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={processing} />
      <Grid>
        <Card>
          <CardContent>
            <FormHelperText style={{ fontWeight: "bold" }}>
              Add Event Sponsor
            </FormHelperText>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && name === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {inputError && name === "" && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  placeholder="Link"
                  label="Link"
                  variant="standard"
                  fullWidth
                  required
                  error={inputError && link === ""}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                />
                {inputError && link === "" && (
                  <FormHelperText className={classes.error}>
                    Link Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={2}>
                <label htmlFor="contained-button-file">
                  <Input
                    accept="image/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: "none" }}
                    onChange={(e) => uploadFile(e)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    style={{ marginTop: "10px" }}
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
              <Grid item xs={12} sm={10}>
                <TextField
                  placeholder="File Name"
                  label="File Name"
                  variant="standard"
                  fullWidth
                  required
                  disabled
                  error={inputError}
                  InputProps={{
                    className: classes.copy,
                  }}
                  value={fileName}
                />
                {inputError && (
                  <FormHelperText className={classes.error}>
                    Image Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                direction="row"
                style={{ marginRight: "10px" }}
              >
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ color: "#82B288", marginTop: "20px" }}
                    type="submit"
                    variant="outlined"
                    fullWidth
                    onClick={() => openModal(false)}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} sm={3}>
                  <Button
                    style={{ marginTop: "20px", marginLeft: "10px" }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => addSponsor()}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
